import i18n from '@/locales';
import store from '@/store'; // 

/** v-tooltip Is there a tooltip to start with */

let tooltipNum = 0, tooltipEl = null;

const hasTooltip = {
  inserted(el, binding, vnode) {
    const value = binding.value;
    el.className = el.className + ' base-text-nowrap';
    if (value && el) {
      el.addEventListener('mouseenter', (e) => {
        if (el.scrollWidth > el.offsetWidth) {
          if (!e.target.tooltipId) {
            tooltipEl = null;
            tooltipNum++;
            el.tooltipId = 'tooltip' + tooltipNum;
          } else {
            tooltipEl = document.getElementById(el.tooltipId);
          }
          const style = window.getComputedStyle(el);
          const paddingTop = parseFloat(style.paddingTop);
          const paddingBottom = parseFloat(style.paddingBottom);
          const lineHeight = parseFloat(style.lineHeight);
          const top = el.getBoundingClientRect().top + paddingTop;
          const height = el.offsetHeight;
          const positiveTop = top;
          const positiveBottom = window.innerHeight - el.getBoundingClientRect().top;
          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = el.tooltipId;
            tooltipEl.innerText = el.innerText;
            tooltipEl.addEventListener('mouseleave', e => { e && e.style && (e.style.display = 'none'); });
            tooltipEl.style.left = `${(el.getBoundingClientRect().left + 0.5 * el.offsetWidth)}px`;
            tooltipEl.style.bottom = `calc(${positiveBottom}px + 0.5rem )`;
            tooltipEl.style.display = 'block';
            tooltipEl.style.whiteSpace = 'pre-wrap';
            document.body.append(tooltipEl);
          } else {
            tooltipEl.innerText = el.innerText;
            tooltipEl.style.left = `${(el.getBoundingClientRect().left + 0.5 * el.offsetWidth)}px`;
            tooltipEl.style.bottom = `calc(${positiveBottom}px + 0.5rem )`;
            tooltipEl.style.display = 'block';
          }
        }
      })
      el.addEventListener('mouseleave', (e) => {
        tooltipEl = document.getElementById(e.target.tooltipId);
        if (tooltipEl) {
          tooltipEl.style.display = 'none';
        }
      })
    }
  }
};

/** v-tooltip Is there a tooltip available-------------------end */

/** v-tooltip Does the role have permission-------------------start */

const hasPermi = {
  /* el, binding, vnode */
  inserted(el, binding) {
    const { value } = binding
    const all_permission = "*:*:*";
    const permissions = store.getters && store.getters.permissions;

    if (value && value instanceof Array && value.length > 0) {
      
      const permissionFlag = value

      const hasPermissions = permissions.some(permission => {
        return all_permission === permission || permissionFlag.includes(permission)
      })

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
};

/** v-tooltip Does the role have permission-------------------end */

/** v-tooltip current role-------------------start */

const hasRole = {
  inserted(el, binding, vnode) {
    const value = binding.value
    const super_admin = "super_admin";
    const roles = store.getters && [store.getters.curRoleKey]

    if (value && value instanceof Array && value.length > 0) {
      const roleFlag = value

      const hasRole = roles.some(role => {
        return super_admin === role || roleFlag.includes(role)
      })

      if (!hasRole) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置角色权限标签值"`)
    }
  }
};
/** v-tooltip current role-------------------end */

/** v-btnDisabledTip Button disable prompt message-------------------start */
let disabledTipNum = 0, disabledTipEl = null;

const hasDisabledTip = {
  inserted(el, binding, vnode) {
    const value = binding.value;
    if (value && el) {
      el.addEventListener('mouseenter', (e) => {
        if(e.target && e.target.disabled) {
          if(!el.disabledTipId) {
            disabledTipEl = null;
            el.disabledTipId = 'disabledTip' + disabledTipNum ++;
          } else {
            disabledTipEl = document.getElementById(el.disabledTipId);
          }
          const clientRect = el.getBoundingClientRect();
          if (!disabledTipEl) {
            disabledTipEl = document.createElement('div');
            disabledTipEl.id = el.disabledTipId;
            document.body.append(disabledTipEl);
          }
          disabledTipEl.innerText = i18n.messages[i18n.locale][el.innerText] || '请先勾选一项后按删除键';
          disabledTipEl.style.display = 'block';
          const width = disabledTipEl.offsetWidth;
          const height = disabledTipEl.offsetHeight;
          if((e.pageX + width) > window.innerWidth) {
            disabledTipEl.style.left = 'none';
            disabledTipEl.style.right = 0 + 'px';
          } else {
            disabledTipEl.style.left = e.pageX + 'px';
          }
          if((e.pageY + height + 20) > window.innerHeight) {
            disabledTipEl.style.top = 'none';
            disabledTipEl.style.bottom = 0 + 'px';
          } else {
            disabledTipEl.style.top = e.pageY + 20 + 'px';
          }
        }
      });
      
      el.addEventListener('mouseleave', (e) => {
        if(e.target && e.target.disabled) {
          disabledTipEl = document.getElementById(e.target.disabledTipId);
          if (disabledTipEl) {
            disabledTipEl.style.display = 'none';
          }
        }
      })
    }
  }
}
/** v-btnDisabledTip Button disable prompt message-------------------start */

/**
* v-tooltipMore ---------------------start
*/

let tooltipMoreEl = null;

const hasTooltipMore = {
  inserted(el, binding, vnode) {
    const value = binding.value;
    el.className = el.className.split(' ').concat(value).join(' ');
    if (value && el) {
      el.addEventListener('mouseenter', (e) => {
        if (el.scrollHeight > el.offsetHeight) {
          if (!e.target.tooltipId) {
            tooltipMoreEl = null;
            tooltipNum++;
            el.tooltipId = 'tooltip' + tooltipNum;
          } else {
            tooltipMoreEl = document.getElementById(el.tooltipId);
          }
          const height = el.offsetHeight;
          const positiveTop = el.getBoundingClientRect().y + height;
          const positiveBottom = window.innerHeight - el.getBoundingClientRect().top;
          if (!tooltipMoreEl) {
            tooltipMoreEl = document.createElement('div');
            tooltipMoreEl.addEventListener('mouseleave', e => { e && e.style && (e.style.display = 'none'); });
            tooltipMoreEl.className = (tooltipMoreEl.className || '').split('').concat('base-direction-top').join(' ');
            tooltipMoreEl.id = el.tooltipId;
            tooltipMoreEl.innerText = el.innerText;
            tooltipMoreEl.style.left = `${(el.getBoundingClientRect().left + 0.5 * el.offsetWidth)}px`;
            tooltipMoreEl.style.top = `calc(${positiveTop}px + 0.5rem )`;
            tooltipMoreEl.style.display = 'block';
            tooltipMoreEl.style.whiteSpace = 'pre-wrap';
            document.body.append(tooltipMoreEl);
          } else {
            tooltipMoreEl.innerText = el.innerText;
            tooltipMoreEl.style.left = `${(el.getBoundingClientRect().left + 0.5 * el.offsetWidth)}px`;
            tooltipMoreEl.style.top = `calc(${positiveTop}px + 0.5rem )`;
            tooltipMoreEl.style.display = 'block';
          }
        }
      })
      el.addEventListener('mouseleave', (e) => {
        tooltipMoreEl = document.getElementById(e.target.tooltipId);
        if (tooltipMoreEl) {
          tooltipMoreEl.style.display = 'none';
        }
      })
    }
  }
}

/**
* v-tooltipMore ---------------------end
*/

export {
  hasTooltip,
  hasPermi,
  hasRole,
  hasDisabledTip,
  hasTooltipMore
 };